export const button = `
  flex flex-col
  items-center justify-center
  rounded-full
  bg-white
  text-ll-placeholder
  border border-ll-border
  w-10 h-10
  p-2
  flex-none
  transition-colors
  hover:bg-ll-placeholder
  hover:text-white
  hover:border-transparent
`;

export const icon = `
  h-4 w-4
  text-inherit
  inline-block
`;
